// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OOjVS","content":"styles_content__1y5Bx","tableWrap":"styles_tableWrap__EyLXu"};